import DOMPurify from 'dompurify';

// Add a hook to make all links open a new window
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
  }
});

/**
 * Sanitizes Phone Capture Disclosure text (passed as HTML), removing any tags
 * except for inline links.
 * @param {string} text Disclosure text which may be in HTML format.
 * @returns {string} Sanitized disclosure text which can be safely displayed on our modal.
 */
export function sanitizeDisclosureText(text: string): string {
  if (!DOMPurify.isSupported) {
    throw new Error(
      'Disclosure sanitization is not supported in this browser.',
    );
  }

  return DOMPurify.sanitize(text, {ALLOWED_TAGS: ['a']});
}

/**
 * Extracts the text content from HTML, discarding any tags.
 * @param {string} html A string of HTML.
 * @returns {string} Text content of the HTML, discarding any tags.
 */
function getTextFromHTML(html: string): string {
  if (!DOMPurify.isSupported) {
    throw new Error(
      'Disclosure sanitization is not supported in this browser.',
    );
  }

  return DOMPurify.sanitize(html, {ALLOWED_TAGS: []});
}

/**
 * Returns the character count of the text content of the HTML with all tags discarded.
 * @param {string} html A string of HTML.
 * @returns {number} The character count of the text content of the HTML with all tags discarded.
 */
export function getHTMLTextLength(html: string): number {
  return getTextFromHTML(html).length;
}
